import React from 'react';

type Props = {
    title: string;
    description: string;
};

export const EventsDescriptionCard: React.FC<Props> = ({ title, description }) => {
    return (
        <div className="events-description-card">
            <h2 className="title">{title}</h2>
            <p className="description">{description}</p>
        </div>
    );
};
